/**
 * The one signal that a decision was just recorded from this browser tab:
 * approve or decline on the case page, in the approvals inbox or anywhere
 * else the investigate client's decision calls are used. The header's
 * pending count listens for it and re-reads, so a decision moves the count
 * at once, with no timer behind it.
 */
export const APPROVAL_DECIDED_EVENT = 'operations:approval-decided'

export function announceApprovalDecided() {
  if (typeof window === 'undefined' || typeof window.dispatchEvent !== 'function') return
  window.dispatchEvent(new Event(APPROVAL_DECIDED_EVENT))
}
